// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"acl_wrapper__2m5Hx","header":"acl_header__1Vge9","content":"acl_content__1l1EQ"};